import { Component, OnInit, OnDestroy } from '@angular/core';
import { finalize, first, takeUntil } from 'rxjs/operators';
import { AppSettings } from '@app/app.settings';

import { Kb } from '@models';
import { ServicePreferences } from '@services';
import { Subject } from 'rxjs';

@Component({
    selector: 'preferences-keep-filters',
    templateUrl: './preferences-keep-filters.component.html',
    styleUrls: ['./preferences-keep-filters.component.scss']
})
export class PreferencesKeepFiltersComponent implements OnInit, OnDestroy {

    public saving = false;
    public currentUserValue: boolean;

    private _destroyed$ = new Subject();

    constructor(
        private appSettings: AppSettings,
        private servicePreferences: ServicePreferences
    ) {
    }

    ngOnInit() {
        this.currentUserValue = this.servicePreferences.getPreference('keepFilters');
    }

    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
        this._destroyed$.unsubscribe();
    }

    toggleValue($event) {
        this.currentUserValue = $event.checked;
        this.appSettings.settings.keepFilters = $event.checked;

        this.saving = true;
        this.servicePreferences.savePreference({'keepFilters': $event.checked}).pipe(
            finalize(() => {
                this.saving = false;
            }),
            first(),
            takeUntil(this._destroyed$)
        ).subscribe();
    }
}
